import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mfManageForecastTreeData: [],
  mfManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  mfManageForecastFinalTreeData: [],
};

const MFManageScreenRedux = createSlice({
  name: "MFManageScreenRedux",
  initialState,
  reducers: {
    setMFManageForecastTreeData: (state, action) => {
      state.mfManageForecastTreeData = action.payload;
    },
    setMFManageForecastBottlerData: (state, action) => {
      state.mfManageForecastBottlerData = action.payload;
    },
    setMFManageForecastFinalTreeData: (state, action) => {
      state.mfManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setMFManageForecastTreeData,
  setMFManageForecastBottlerData,
  setMFManageForecastFinalTreeData,
} = MFManageScreenRedux.actions;
export default MFManageScreenRedux.reducer;
